import AppBody from './AppBody';
import BottomFixed from './BottomFixed';
import ConnectedModals from 'components/ConnectedModals';
import CustomInStreamAd from 'ads/shims/CustomInStreamAd';
import dispatchDeferredAction from 'utils/dispatchDeferredAction';
import FullScreenPlayerModal from 'components/Player/FullScreenPlayerModal';
import globalStyles from './globalStyles';
import Growls from 'components/Growls';
import Head from './Head';
import Header from 'components/Header';
import IProvideRadio from 'components/IProvideRadio';
import MiniPlayer from 'components/Player/MiniPlayer';
import OfflineHandler from 'components/OfflineHandler';
import ReorderPlaylistContext from 'contexts/ReorderPlaylist';
import SideNav from 'components/SideNav';
import SoftGate from 'views/App/SoftGate';
import Targeting from 'ads/components/Targeting';
import useMount from 'hooks/useMount';
import { getIsLoggedOut } from 'state/Session/selectors';
import { Global } from '@emotion/react';
import type { FunctionComponent, ReactNode } from 'react';
import type { Store } from 'redux';

type Props = {
  children: ReactNode;
  lang: string;
  store: Store;
};

const App: FunctionComponent<Props> = ({ store, children, lang }) => {
  const state = store.getState();
  const loggedOut = getIsLoggedOut(state);

  useMount(() => {
    if (loggedOut) return;
    dispatchDeferredAction();
  });

  return (
    <IProvideRadio lang={lang} store={store}>
      <Global styles={globalStyles} />
      <Head lang={lang} />
      <SoftGate />
      <SideNav />
      <Header />
      <AppBody>{children}</AppBody>
      <ReorderPlaylistContext.Consumer>
        {({ active }) => (
          <BottomFixed reorderActive={active}>
            <MiniPlayer />
          </BottomFixed>
        )}
      </ReorderPlaylistContext.Consumer>
      <Growls />
      <ConnectedModals />
      <FullScreenPlayerModal />
      <Targeting />
      <CustomInStreamAd />
      <OfflineHandler />
    </IProvideRadio>
  );
};

export default App;
